import {
  createApi,
  createAuth,
  createCart,
  createStorage,
  createStrapi,
  createHttpFactory
} from "@monta/utils";

const storage = createStorage();

const auth = createAuth(storage, {});

// Create HTTP factory with auth instance
const httpFactory = createHttpFactory(auth, {
  enableGlobalErrorHandling: true,
  enableRequestLogging: process.env.NODE_ENV === "development",
  enableResponseLogging: process.env.NODE_ENV === "development",
  onUnauthorized: () => {
    console.log("User unauthorized, redirecting to login...");
    // * Additional custom logic here
  },
  onForbidden: () => {
    console.log("Access forbidden");
    // * Additional custom logic here
  },
  onNetworkError: (error) => {
    console.error("Network error occurred:", error);
    // * Additional custom logic here
  }
});

// Create HTTP clients with enhanced features
const httpClients = {
  monolithic: httpFactory.createMonolithicClient(),
  gwt: httpFactory.createGwtClient(),
  node: httpFactory.createNodeClient()
};

const api = createApi({
  auth
});

const cart = createCart(api);

const strapi = createStrapi();

export { api, auth, storage, cart, strapi, httpFactory, httpClients };
